/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrStandingEntry
 */
export interface RttrStandingEntry {
    /**
     * 
     * @type {number}
     * @memberof RttrStandingEntry
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof RttrStandingEntry
     */
    username: string;
    /**
     * User's avatar URL (gravatar/profilePicture). Empty/undefined when the user has not uploaded one — frontend falls back to initials.
     * @type {string}
     * @memberof RttrStandingEntry
     */
    avatarUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof RttrStandingEntry
     */
    value: number;
    /**
     * 
     * @type {boolean}
     * @memberof RttrStandingEntry
     */
    isQualified: boolean;
}

/**
 * Check if a given object implements the RttrStandingEntry interface.
 */
export function instanceOfRttrStandingEntry(value: object): value is RttrStandingEntry {
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('isQualified' in value) || value['isQualified'] === undefined) return false;
    return true;
}

export function RttrStandingEntryFromJSON(json: any): RttrStandingEntry {
    return RttrStandingEntryFromJSONTyped(json, false);
}

export function RttrStandingEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrStandingEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'],
        'username': json['username'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'value': json['value'],
        'isQualified': json['isQualified'],
    };
}

export function RttrStandingEntryToJSON(json: any): RttrStandingEntry {
    return RttrStandingEntryToJSONTyped(json, false);
}

export function RttrStandingEntryToJSONTyped(value?: RttrStandingEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'username': value['username'],
        'avatarUrl': value['avatarUrl'],
        'value': value['value'],
        'isQualified': value['isQualified'],
    };
}

